function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0,
  y: 13,
  width: 4,
  height: 5,
  fill: "#333"
}, React.createElement("animate", {
  attributeName: "height",
  attributeType: "XML",
  values: "5;21;5",
  begin: "0s",
  dur: "0.6s",
  repeatCount: "indefinite"
}), React.createElement("animate", {
  attributeName: "y",
  attributeType: "XML",
  values: "13; 5; 13",
  begin: "0s",
  dur: "0.6s",
  repeatCount: "indefinite"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 10,
  y: 13,
  width: 4,
  height: 5,
  fill: "#333"
}, React.createElement("animate", {
  attributeName: "height",
  attributeType: "XML",
  values: "5;21;5",
  begin: "0.15s",
  dur: "0.6s",
  repeatCount: "indefinite"
}), React.createElement("animate", {
  attributeName: "y",
  attributeType: "XML",
  values: "13; 5; 13",
  begin: "0.15s",
  dur: "0.6s",
  repeatCount: "indefinite"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 20,
  y: 13,
  width: 4,
  height: 5,
  fill: "#333"
}, React.createElement("animate", {
  attributeName: "height",
  attributeType: "XML",
  values: "5;21;5",
  begin: "0.3s",
  dur: "0.6s",
  repeatCount: "indefinite"
}), React.createElement("animate", {
  attributeName: "y",
  attributeType: "XML",
  values: "13; 5; 13",
  begin: "0.3s",
  dur: "0.6s",
  repeatCount: "indefinite"
}));

var SvgLoaderMessage = function SvgLoaderMessage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "30px",
    viewBox: "0 0 24 30",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLoaderMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loader-message.45b49783.svg";
export { ForwardRef as ReactComponent };